import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutRateAdjustments extends Layout {
    sourceOriginDestinationRate: DataSource;
    tableRateAdjustments: Table;
}
